export default {
  // Hängt ein Duplikat an den Namen des Originals ("Beton C25/30 (Kopie)"). Stammdaten-Namen sind
  // eindeutig, ein unveränderter Name würde beim Speichern abgelehnt.
  copy_suffix: "(Kopie)",
  close: "Schließen",
  loading: "Lade...",
  show_more: "Mehr anzeigen",
  show_less: "Weniger anzeigen",
  // Tab-Titel der 404-Seite (`meta.title` der NotFound-Route).
  not_found_page: "Seite nicht gefunden",
  // Die Übersichten von Materialien, Maschinen und Zusatzleistungen.
  catalog_row: {
    headers: {
      changed: "Zuletzt geändert",
    },
  },
  // Die Auswahlfelder der Berichte (Personal, Geräte, Material, Zusatzleistungen): wer ins Projekt
  // eintragen darf, bekommt unter den Einträgen des Projekts auch die des Kunden und der Stammdaten.
  // Ein solcher Eintrag kommt beim Speichern des Berichts ins Projekt (docs/report-panels.md).
  report_assignment: {
    groups: {
      project: "Im Projekt",
      customer: "Beim Kunden",
      catalogue: {
        users: "Weitere Mitarbeiter",
        machines: "Aus den Stammdaten",
        materials: "Aus den Stammdaten",
        additionalEfforts: "Aus den Stammdaten",
      },
    },
    // Hinter den Gruppen außerhalb des Projekts.
    assigns: "wird dem Projekt zugeordnet",
    more: "Nicht alle Treffer angezeigt. Bitte Suche verfeinern.",
    searching: "Suche läuft…",
    new_tag: "Neu im Projekt",
    dialog_title: "Neu im Projekt",
    dialog_text: {
      customer: "Beim Kunden hinterlegt, aber noch nicht im Projekt. Wird beim Speichern zugeordnet.",
      catalogue: "Noch nicht im Projekt. Wird beim Speichern zugeordnet.",
    },
    customer_takeover: "Verkaufspreis wird für den Kunden mit übernommen.",
  },
  // Unter der Menge im Dialog eines Materials, das der Bericht (die Schicht) zum selben Preis schon bucht:
  // die Menge kommt zu dieser Zeile dazu, statt eine zweite anzulegen.
  booked_amount: {
    already: "Bereits {amount} gebucht",
    combined: "Bereits {amount} gebucht · zusammen {total}",
  },
  // Die Geräte, die ein Berichtseintrag bucht (Bautagesbericht und Stundenlohnbericht): Nummern
  // auswählen oder neu eintippen.
  device_numbers: {
    label: "Geräte-Nummer",
    add: "Neue Geräte-Nummer…",
    available: "Verfügbar",
    taken: "Geräte-Nr. {number} gehört zu {machine}.",
    // Unter den gewählten Nummern einer Maschine, die das Projekt schon hat, für die neuen davon: das
    // Speichern des Berichts gibt sie der Maschine im Projekt.
    adds_to_project:
      "{numbers} ist neu und kommt beim Speichern zur Maschine ins Projekt. | {numbers} sind neu und kommen beim Speichern zur Maschine ins Projekt.",
  },
  // Einkaufspreise einer Maschine / eines Materials: dieselbe Position kann bei verschiedenen Quellen
  // unterschiedlich viel kosten. Eine Variante ist der Standard.
  purchase_price_variants: {
    title: "Einkaufspreise",
    label: "Bezeichnung (z. B. Lieferant)",
    // So heißt ein Preis ohne Bezeichnung. Nicht „Standard“: der muss nicht der Standardpreis sein, und
    // das Wort gehört dem Schalter, der einen dazu macht.
    unnamed: "Ohne Bezeichnung",
    price: "Einkaufspreis",
    currency: "Währung",
    default: "Standard",
    add: "Einkaufspreis hinzufügen",
    remove: "Einkaufspreis entfernen",
    missing_in_currency:
      "Kein Preis in {currency} hinterlegt. Buchungen zu diesem Preis gehen mit 0 in die Kosten ein.",
    also_in: "Auch hinterlegt:",
    show_currency: "Preis in {currency} anzeigen",
    unique_label: "Diese Bezeichnung ist bereits vergeben.",
    unique_unnamed: "Nur ein Einkaufspreis kann ohne Bezeichnung bleiben.",
    select: "Einkaufspreis",
    select_hint: "Zu welchem Preis wurde eingekauft?",
    more_count: "+{count} weiterer | +{count} weitere",
    count: "{count} Einkaufspreis | {count} Einkaufspreise",
    range: "{min} – {max}",
    removed: "entfernt",
    live_price: "aktueller Preis",
    live_price_hint:
      "Diese Buchung stammt von vor der Preisfestschreibung und wird mit dem heutigen Einkaufspreis gerechnet.",
    // Auf der Maschine bzw. dem Material, unter einem Einkaufspreis: die Projekte, die mit einem anderen
    // rechnen („5 Projekte: 505,00 EUR“), und in einem Dialog jedes mit seinem Preis. Namen und Daten werden
    // nie als Parameter eingesetzt: escapeParameter machte aus „C25/30“ „C25&#x2F;30“.
    in_projects: {
      title: "Einkaufspreise in Projekten",
      count: "{count} Projekt | {count} Projekte",
      // Davor steht der Name eines Preises, den nur Projekte haben.
      only_in: "nur in {count} Projekt | nur in {count} Projekten",
      not_in_record: "nicht in den Stammdaten",
      // Danach folgt der Preis der Stammdaten.
      record: "Stammdaten:",
      record_no_price: "kein Preis in {currency}",
      project: "Projekt",
      price: "Preis",
      difference: "Abweichung",
      // Danach folgt der Name, den das Projekt dem Preis gegeben hat.
      project_label: "im Projekt:",
      // Danach folgt das Datum.
      since: "seit",
      hint_kept: "Ein Projekt behält seine Preise, auch wenn sie hier geändert werden.",
      has_more: "Verglichen werden die {count} neuesten Projekte.",
    },
  },
  // Das Menü neben einem Verkaufspreis, beim Kunden wie im Projekt. Gespeichert wird „Zum Einkaufspreis“
  // als Aufschlag von 0 % und „Ohne Berechnung“ als Festpreis von 0 – kostenlos, nicht „nicht gesetzt“.
  selling_price: {
    kind_menu: "Art des Verkaufspreises",
    kinds: {
      fixed: "Festpreis",
      variable: "Aufschlag",
      purchase_price: "Zum Einkaufspreis",
      free: "Ohne Berechnung",
    },
    purchase_price_hint: "Der Verkaufspreis ist der Einkaufspreis, der gebucht wird.",
    free_hint: "Kostenlos: der Verkaufspreis ist {amount}.",
  },
  // Einheiten von Maschinen und Zusatzleistungen (Enum `MeasurementUnit`). Nur die Zeit- und
  // Stückeinheiten brauchen eine Übersetzung; alle anderen zeigen ihr SI-Kürzel aus measurement_units.js.
  units: {
    short: {
      HOUR: "h",
      DAY: "Tag | Tage",
      PIECE: "Stk. | Stk.",
      FLAT_RATE: "psch",
      SQUARE_METER: "m²",
      RUNNING_METER: "lfm",
      WEEK: "Wo",
      MONTH: "Mon",
      SET: "Satz",
    },
    long: {
      HOUR: "Stunde",
      DAY: "Tag",
      PIECE: "Stück",
      FLAT_RATE: "Pauschal",
      RUNNING_METER: "Laufender Meter",
      WEEK: "Woche",
      MONTH: "Monat",
      SET: "Satz",
    },
    legacy: "Bisherige Einheit (Freitext)",
    unresolved: "Einheit prüfen",
    unresolved_hint: "Einheit prüfen: bisher „{legacy}“",
  },
  importExport: {
    title: "Import / Export",
    export: "Exportieren",
    import: "Importieren",
    exportDialog: {
      title: "Exportieren",
      what: "Inhalt",
      dataOption: "Alle Daten",
      templateOption: "Leere Vorlage",
      format: "Format",
      germanOption: "Für Excel",
      technicalOption: "Standard-CSV",
      submit: "Herunterladen",
    },
    dialog: {
      title: "Daten importieren",
      fileLabel: "Datei",
      drop: "CSV-Datei hierher ziehen oder auswählen",
      existingLabel: "Vorhandene Daten",
      skipOption: "Überspringen",
      updateOption: "Aktualisieren",
      employeeMatchHint: "Abgleich über die Personalnummer, ersatzweise über Vor- und Nachname.",
      noFile: "Bitte wählen Sie zuerst eine CSV-Datei aus.",
      invalidType: "Bitte wählen Sie eine CSV-Datei (.csv).",
      submit: "Importieren",
    },
    result: {
      totalRows: "Zeilen gesamt",
      created: "Erstellt",
      updated: "Aktualisiert",
      skipped: "Übersprungen",
      failed: "Fehlgeschlagen",
      errorsTitle: "Fehlerhafte Zeilen",
      row: "Zeile",
      field: "Feld",
      message: "Meldung",
    },
  },
  map: {
    // OSM credit — "OpenStreetMap contributors" (the canonical English form is
    // compliant in every locale, so we keep it in German too).
    osm_attribution:
      "&copy; <a href='https://www.openstreetmap.org/copyright' target='_blank' rel='noopener'>OpenStreetMap</a> contributors",
    address_search: {
      // Ersetzt das Suchfeld, wenn die Adresssuche nicht erreichbar ist. Der Anbieter
      // wird bewusst nicht genannt — wichtig ist nur, dass es einen anderen Weg gibt.
      unavailable: "Adresssuche derzeit nicht verfügbar",
      retry: "Erneut versuchen",
    },
  },
  // Die Adress-Sektion (`LewAddressSection`) — dieselben Feldnamen für jede Maske, die
  // eine Anschrift erfasst, und für die Änderungshistorie dieser Felder.
  address: {
    search_placeholder: "Geben Sie eine Adresse ein",
    edit_manually: "Adresse manuell bearbeiten",
    street: "Straße",
    house_number: "Hausnummer",
    postcode: "Postleitzahl",
    place: "Ort",
    state: "Bundesland",
    country: "Land",
  },
  // Der Wetterverlauf einer Schicht (`LewWeatherCourse`) unter den drei Wetterangaben einer Schicht im
  // Bautagesbericht; die Stundenreihe der Tagesmeldung nutzt dieselben Wortlaute. Die Wetterlagen selbst
  // stehen in services/weather.js.
  weather_course: {
    // Die Leiste mit jeder Stunde, für Screenreader.
    hourly: "Wetter Stunde für Stunde",
    temperature: "{value} °C",
    temperature_range: "{min}–{max} °C",
    precipitation: "{amount} mm",
    precipitation_long: "{amount} mm Niederschlag",
    gusts: "Böen bis {speed} km/h",
  },
  // Die Abschnitte des Protokoll-Tabs (`LewEntityActivity`). Hier und nicht in einer Feature-Datei,
  // weil derselbe Tab an acht Datensatzarten hängt und überall gleich heißen muss.
  activity: {
    metadata: "Metadaten",
    id: "ID",
    references: "Verweise",
    references_empty: "Auf diesen Datensatz verweist nichts.",
    references_more: "und {count} weitere",
    // Die zwei Wege zum Rest einer Art. Der Link geht in die eigene Übersicht dieser Art, auf diesen
    // Datensatz gefiltert; nachgeladen wird nur dort, wo es keine solche Übersicht gibt.
    references_show_all: "Alle anzeigen",
    references_load_more: "Weitere laden",
    // Kopfzeile der gefilterten Übersicht, mit dem Namen des Datensatzes, auf den gefiltert wird.
    filtered_by_reference: "Gefiltert: verweist auf {name}",
    filter_clear: "Filter aufheben",
    // Tooltip der Verweis-Chips. Sie sind zugleich die Übersicht und der Filter: die Zahl sagt,
    // wie viele es gibt, ein Klick zeigt nur diese.
    filter_by: "Nur diese Art anzeigen",
    history: "Protokoll",
    // Datums-Überschriften im Protokoll. Nur diese beiden Tage bekommen einen Namen — bei allem
    // anderen ist das Datum selbst die Antwort auf "wann war das".
    today: "Heute",
    yesterday: "Gestern",
    history_empty: "Für diesen Datensatz wurde noch keine Änderung aufgezeichnet.",
    // Das Projekt-Protokoll listet auch Leistungskatalog, Berichte und Regierechnungen; die Chips darüber
    // grenzen es auf einige davon ein. Dieser Chip steht für das Projekt selbst.
    kind_project: "Projekt",
    history_empty_filtered: "Für diese Auswahl wurde noch keine Änderung aufgezeichnet.",
    // Getrennt von den Leer-Texten: eine fehlgeschlagene Abfrage weiß nicht, ob es nichts gibt.
    load_failed: "Konnte nicht geladen werden.",
  },
  // Die Feldnamen der Datensatz-Fakten. Ohne Doppelpunkt: `LewEntityMeta` setzt ihn selbst, weil
  // dort Name und Wert in einer Zeile stehen — im Protokoll-Tab stehen sie untereinander.
  meta: {
    created_at: "Erstellt am",
    created_by: "Erstellt von",
    last_modified_at: "Zuletzt bearbeitet am",
    last_modified_by: "Zuletzt bearbeitet von",
  },
  // Tastenbeschriftungen in Tastenhinweisen (LewKeyHints). Auf macOS steht dort ⌘.
  keys: {
    ctrl: "Strg",
  },
  // Archivieren statt Löschen (docs/archiving.md): „Entfernen“ und „Reaktivieren“ der Detailseiten, ihr Hinweis
  // und das Archiv der Übersichten, das ihr ⋮ öffnet.
  archive: {
    remove_title: "Entfernen?",
    remove_title_named: "„{name}“ entfernen?",
    remove_text:
      "Der Eintrag verschwindet aus allen Übersichten und Auswahllisten. Wird er schon verwendet, bleibt er dort erhalten und kommt ins Archiv, wo du ihn jederzeit reaktivieren kannst. Sonst wird er gelöscht.",
    restore: "Reaktivieren",
    banner: "Archiviert am {date}",
    banner_by: "Archiviert am {date} von {name}",
    banner_hint: "Erscheint in keiner Übersicht und Auswahlliste mehr.",
    badge: "Archiviert",
    // Das ⋮ einer Übersicht und die Archivansicht, die es öffnet.
    show: "Archiv anzeigen",
    overview_hint: "Erscheinen in keiner Übersicht und Auswahlliste. Öffne einen Eintrag, um ihn zu reaktivieren.",
  },
  actions: {
    agree: "Zustimmen",
    // Beschriftet die Aktionen-Schaltfläche im Kopf einer Detailseite (`LewEntityPage`).
    actions: "Aktionen",
    submit: "Speichern",
    cancel: "Abbrechen",
    create: "Erstellen",
    // Die eine Schaltfläche über einem Katalog (Material, Maschine, Zusatzleistung): ihr Menü bietet
    // den Katalogeintrag und das Paket an, beide mit ihrer eigenen Beschriftung.
    create_new: "Neu anlegen",
    apply: "Übernehmen",
    // Generische Verben für Icon-Buttons ohne eigene, bildschirmspezifische Formulierung.
    // Alles mit einem Fach-Substantiv daran ("Bericht löschen") gehört in die Datei des Screens.
    add: "Hinzufügen",
    edit: "Bearbeiten",
    delete: "Löschen",
    // Stammdaten-Seiten (Material, Maschine, Zusatzleistung): öffnen ein Formular, schreiben nichts.
    duplicate: "Duplizieren",
    create_packet: "Paket daraus erstellen",
    remove: "Entfernen",
    // Das ⋮ neben dem Anlegen-Button einer Übersicht.
    more: "Weitere Aktionen",
    open: "Öffnen",
    download: "Herunterladen",
    restore: "Wiederherstellen",
    expand: "Details anzeigen",
    collapse: "Details ausblenden",
  },
  table: {
    loading_text: "Lade Elemente...",
    // Der Pfeil am Zeilenende: Beschriftung und Tooltip. Ein Rechtsklick auf die Zeile tut dasselbe.
    expand_row: "Details aufklappen",
    collapse_row: "Details zuklappen",
    right_click_hint: "{action} (auch mit Rechtsklick auf die Zeile)",
    // Die Nadel am Zeilenende: Beschriftung für Screenreader (ob sie gesetzt ist, sagt `aria-pressed`) und
    // Tooltip für die Maus, in den Worten der Kalender der Personalplanung. Angepinnte Zeilen stehen nur für
    // die angemeldete Person oben.
    pin: "Anpinnen",
    pin_hint: "Oben in der Liste anpinnen (nur für Sie)",
    unpin_hint: "Loslösen",
    no_data_text: "Keine Daten vorhanden",
    no_results_text: "Keine Elemente gefunden",
    no_more_items: "Keine weiteren Daten verfügbar",
    load_more: "Mehr Laden",
    scroll_to_top: "Nach oben",
    // Kartenlisten (schmale Viewports) haben keine Spaltenköpfe zum Klicken — Sortieren wandert
    // deshalb in ein Menü.
    sort_by: "Sortieren",
    sort_ascending: "Aufsteigend",
    sort_descending: "Absteigend",
    select_all: "Alle auswählen",
    clear_selection: "Auswahl aufheben",
    // Die Leiste über einer Liste, sobald etwas angehakt ist.
    selected: "{count} ausgewählt",
    actions: {
      action: "Aktionen",
      delete: "löschen",
      duplicate: "duplizieren",
    },
  },
  modal: {
    close: "Fertig",
  },
  reference: {
    // Steht für einen Verweis (Position, Rolle …), dessen Ziel es nicht mehr gibt. Die technische ID
    // darf nie in der Oberfläche landen — sie sagt niemandem etwas.
    unknown: "Unbekannt",
  },
  error: {
    internal_server_error: "Etwas ist schiefgelaufen.",
    // Fallbacks für abgelehnte Änderungen, die keinen ViolationCode mitliefern (z. B. Feldvalidierung).
    invalid_request: "Die Änderungen konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Eingaben.",
    forbidden: "Für diese Aktion fehlt Ihnen die Berechtigung.",
    not_found: "Der Eintrag wurde nicht gefunden. Möglicherweise wurde er zwischenzeitlich gelöscht.",
    payload_too_large: "Der Upload ist zu groß und wurde abgelehnt.",
    no_response_read: "Der Server hat nicht geantwortet. Bitte versuchen Sie es erneut.",
    no_response_write:
      "Der Server hat nicht geantwortet. Ob die Änderung gespeichert wurde, ist unklar. Bitte prüfen Sie es vor einem erneuten Versuch.",
    // Only for failures reported to Sentry; the trace id joins them to the backend issue.
    reference: "Referenz:",
    referenceCopy: "Referenz kopieren",
    referenceCopied: "Referenz kopiert",
    previous_redirect: "Klicken sie hier um die vorherige Seite aufzurufen.",
    dashboard_redirect: "Oder klicken sie hier um auf das Dashboard aufzurufen.",
  },
  component: {
    combobox: {
      submitNewTag: 'Drücke <kbd>{key}</kbd> um das Tag "<strong>{value}</strong>" zu erstellen',
    },
    file: {
      noDisplayPossible: "Dateiablage erst nach erstmaligem Speichern verfügbar.",
      modal: {
        title: "Datei bearbeiten",
      },
      table: {
        name: "Name",
        createdAt: "Erstellt am",
        // Kurz, weil die Spalte schmal ist und das Datum darin schon sagt, worum es geht.
        dueDate: "Gültig bis",
        tags: "Tags",
        deleteConfirm: {
          title: "Datei löschen?",
          text: 'Möchten Sie "{name}" wirklich löschen?',
          agree: "Löschen",
        },
      },
      form: {
        tags: "Alle Tags",
        download: "Herunterladen",
        view: "Anschauen",
        createdAt: "Hochgeladen um",
        uploadedBy: "Hochgeladen von",
        updatedAt: "Modifiziert um",
        updatedBy: "Modifiziert von",
        // Was auf dem Dokument steht, getrennt vom Upload: das Foto von 14 Uhr, das um 23 Uhr mit dem
        // Bautagesbericht hochgeladen wurde. Der Bericht druckt es im PDF unter derselben Bezeichnung.
        documentDate: "Dokumentdatum",
        documentTime: "Uhrzeit",
        documentDateHelp:
          "Das Datum, das auf dem Dokument steht, bei einem Foto der Zeitpunkt der Aufnahme. Leer lassen, wenn es dem Upload entspricht; dann gilt der Zeitpunkt des Uploads.",
        // Optional und bei den allermeisten Dateien leer: nur Unterlagen, die tatsächlich ablaufen —
        // TÜV, Führerschein, Unterweisung, Bürgschaft — brauchen ein Datum.
        dueDate: "Gültig bis",
        dueLeadDays: "Vorlauf (Tage)",
        // Die beiden Tooltips stehen im Feld, weil der Hinweis nur beim Ausfüllen gebraucht wird und
        // ein fester Hilfstext unter dem Vorlauf die Zeile ungleich hoch gemacht hat.
        dueDateHelp:
          "Datum, bis zu dem das Dokument gültig ist. Danach gilt die Datei als abgelaufen und wird in der Liste markiert. Leer lassen, wenn das Dokument nicht abläuft.",
        // Sagt, was ein leeres Feld bedeutet. Ohne diesen Satz liest es sich wie "keine Warnung".
        dueLeadDaysHelp:
          "Wie viele Tage vor dem Ablauf gewarnt wird. Leer: es gilt der Vorlauf aus den Einstellungen des Arbeitsbereichs.",
      },
      // Der Tooltip an der Spalte sagt, was das Datum allein nicht sagt: wie lange noch, oder wie
      // lange schon vorbei. Das Datum selbst steht bereits in der Zelle.
      due: {
        tooltip: {
          expired: "Seit {days} Tagen abgelaufen",
          today: "Läuft heute ab",
          remaining: "Noch {days} Tage gültig",
          unknown: "Gültig bis",
        },
      },
      pond: {
        maxFileExceeded: "Es können maximal nur {value} Dateien gleichzeitig hochgeladen werden.",
        singleFile: "Bitte nur eine Datei ablegen.",
        maxSizeExceeded: "Die Datei ist zu groß. Erlaubt sind höchstens {value}.",
        dropFilesHere: "Dateien hier ablegen...",
        uploadFailed: "Upload fehlgeschlagen",
        uploadNoAnswer: "Keine Antwort vom Server",
      },
    },
    autocomplete: {
      noDataText: "Nicht gefunden {value}",
      // Solange die erste Seite einer seitenweise geladenen Auswahlliste unterwegs ist.
      searching: "Suche läuft…",
    },
    // Das Ende einer seitenweise geladenen Auswahlliste (`LewLoadMore`), wenn die nächste Seite nicht kam.
    load_more: {
      retry: "Weitere laden",
    },
    table: {
      noDataText: "Keine Daten vorhanden",
    },
    formDialog: {
      close: "Schließen",
      add: "Hinzufügen",
      save: "Speichern",
    },
    confirmationDialog: {
      confirm: "Bestätigen",
      cancel: "Abbrechen",
    },
    dateInput: {
      invalidFormat: "Ungültiges Datum",
    },
  },
  update: {
    message: "Eine neue Version ist verfügbar.",
    action: "Aktualisieren",
  },
  // Goldener Streifen über der App-Leiste und Tab-Titel einer Test-, Vorab- oder Entwicklerversion
  // (APP_BANNER, services/deployment.ts).
  deployment: {
    development: "Entwicklerversion",
    staging: "Vorabversion",
    test: "Testversion",
    // Vorne im Tab-Titel, wo jedes Zeichen Platz für den Seitennamen kostet.
    short: {
      development: "Dev",
      staging: "Vorab",
      test: "Test",
    },
  },
  // „Speichern & neu“ und „Speichern & kopieren“ neben dem Speichern einer Anlegeseite, und die Meldung
  // danach. Siehe docs/navigation.md.
  create_series: {
    save_and_new: "Speichern & neu",
    save_and_copy: "Speichern & kopieren",
    more: "Weitere Speicheroptionen",
    created: "„{name}“ angelegt",
  },
  // Ungespeicherte Änderungen: die Zeile neben dem Speichern-Knopf, die Frage vor dem Verlassen und das
  // Angebot, einen im Browser gesicherten Entwurf zurückzuholen. Siehe docs/unsaved-changes.md.
  unsaved: {
    status: "Ungespeicherte Änderungen",
    dialog: {
      title: "Ungespeicherte Änderungen",
      text: "Was hier geändert wurde, ist noch nicht gespeichert:",
      // Steht da, wenn der Dialog kein Speichern anbietet: bei einem neuen Datensatz (dessen Speichern
      // noch Rückfragen stellen kann) und bei einem offenen Bericht.
      save_there: "Zum Speichern „Weiter bearbeiten“ wählen und dort speichern.",
      stay: "Weiter bearbeiten",
      discard: "Verwerfen",
      save: "Speichern",
    },
    draft: {
      found: "Nicht gespeicherte Änderungen vom {when}",
      outdated: "Seitdem wurde neu gespeichert. Was hier nicht geändert wurde, bleibt aktuell.",
      restore: "Wiederherstellen",
      dismiss: "Verwerfen",
    },
  },
  sentry: {
    formTitle: "Fehler melden",
    isRequiredLabel: "(erforderlich)",
    submitButtonLabel: "Fehlerbericht senden",
    cancelButtonLabel: "Abbrechen",
    confirmButtonLabel: "Bestätigen",
    addScreenshotButtonLabel: "Screenshot hinzufügen",
    removeScreenshotButtonLabel: "Screenshot entfernen",
    messageLabel: "Beschreibung",
    messagePlaceholder:
      "Was wollten Sie tun, und was ist stattdessen passiert? Ein Screenshot hilft uns sehr, das Problem nachzuvollziehen.",
    successMessageText: "Vielen Dank für Ihren Bericht!",
    sent: {
      sending: "Fehlerbericht wird gesendet …",
      title: "Fehlerbericht ist angekommen",
      text: "Vielen Dank! Unser Team hat Ihren Bericht erhalten und kümmert sich schnellstmöglich darum.",
      reply: "Falls wir Rückfragen haben, melden wir uns per E-Mail bei Ihnen.",
      reference: "Vorgangsnummer {reference}",
    },
    // `{'@'}`: a bare @ starts a linked message in vue-i18n.
    errorGenericText:
      "Der Bericht konnte nicht gesendet werden, vielleicht wegen der Internetverbindung oder eines Werbeblockers. Bitte versuchen Sie es erneut oder schreiben Sie an support{'@'}lewara.de.",
    errorTimeoutText:
      "Wir konnten nicht feststellen, ob Ihr Bericht angekommen ist. Bitte senden Sie ihn erneut oder schreiben Sie an support{'@'}lewara.de.",
    errorForbiddenText: "Der Bericht konnte nicht gesendet werden. Bitte schreiben Sie an support{'@'}lewara.de.",
    highlightToolText: "Hervorheben",
    hideToolText: "Verbergen",
    removeHighlightText: "Entfernen",
    priorityLabel: "Priorität",
    priorities: {
      low: "Niedrig",
      normal: "Normal",
      high: "Hoch",
      critical: "Kritisch",
    },
    attachments: {
      attach: "Dateien anhängen",
      remove: "Anhang entfernen",
      tooLarge: "„{name}“ ist zu groß: alle Anhänge zusammen höchstens {max}\u00a0MB.",
      unreadable: "„{name}“ konnte nicht gelesen werden.",
    },
  },
}
